var exports = {
  "kL": "xdbfd91f1--2dc92a--container",
  "DD": "xdbfd91f1--2dc92a--title",
  "iR": "xdbfd91f1--2dc92a--title-head",
  "f6": "xdbfd91f1--2dc92a--title-text",
  "Pt": "xdbfd91f1--2dc92a--icons",
  "Gp": "xdbfd91f1--2dc92a--close-btn",
  "JF": "xdbfd91f1--2dc92a--house-icon",
};

module.exports = exports;
